import graphqlClient from "@/GQLClient";
import type { ExternalEntityVisibilityFragment } from "@/graphql";
import {
  GetExternalEntityVisibilityDocument,
  Module_Type,
  SetExternalEntityVisibilityDocument,
  type SetExternalEntityVisibilityMutationVariables,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import { useAuthStore } from "@/stores/auth.module";

const getVisibilities = async (
  entityType: Module_Type,
): Promise<ExternalEntityVisibilityFragment[]> => {
  const authStore = useAuthStore();

  const response = await graphqlClient.query({
    query: GetExternalEntityVisibilityDocument,
    variables: {
      institutionId: authStore.institutionId,
      entityType,
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.data.institutions?.getEntityVisibility) {
    return response.data.institutions?.getEntityVisibility;
  }

  throw new SentryGraphQLError(`api.externalContent.getVisibilities`, response);
};

const setVisibility = async (
  variables: SetExternalEntityVisibilityMutationVariables,
) => {
  const authStore = useAuthStore();
  variables.institutionId = authStore.institutionId;

  const response = await graphqlClient.query({
    query: SetExternalEntityVisibilityDocument,
    variables,
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.data.institution?.setEntityVisibility?.success) {
    return response.data.institution.setEntityVisibility;
  }

  throw new SentryGraphQLError(`api.externalContent.setVisibility`, response);
};

export default {
  getVisibilities,
  setVisibility,
};
